<template>
  <div class="lite-product-item col-6 my-2">
    <div class="single-product-details h-100 pb-3" :style="{ borderRadius: '5px' }">
      <div class="inline_product clickable d-flex justify-content-center" :style="{
        cursor: 'pointer',
        background: '#3b71de10',
        borderRadius: '5px 5px 0px 0px',
      }">
        <div class="d-flex justify-content-end for-dicount-div-null">
          <span class="for-discoutn-value-null"></span>
        </div>
        <div class="d-flex block" :style="{ cursor: 'pointer' }" @click="onClickView">
          <el-image :src="imgProxy(imageUrl, rs = 'fill:600:600:1')" :alt="dt(item?.name_translations)" :style="{
            width: '100%',
            borderRadius: '5px 5px 0px 0px',
          }">
            <template #error>
              <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(item?.name_translations)"
                :style="{ width: '100%' }">
            </template>
          </el-image>
        </div>
      </div>

      <div class="position-relative" :class="isMobile ? ['text-sm'] : ['text-xl']" :style="{ paddingTop: '10px' }">
        <div class="text-center text-truncate-3 text-lg" :style="{ cursor: 'pointer' }"
          @click="onOpenProductChooseAssortDialog">
          {{ dt(item.name_translations) }}
          <!-- <p v-if="assorts.length == 1" class="text-black-50 text-truncate-2">{{ dt(assorts[0].name_translations) }}</p> -->
        </div>
        <div class="justify-content-between text-center">
          <!-- hiddenPrice = {{ hiddenPrice }} -->
          <div v-if="!hiddenPrice" class="product-price text-center">
            <del class="text-primary" :class="isMobile ? ['text-sm'] : ['text-sm', 'mr-2']">
              {{ aliasTranslations?.comm_price || $t("carts.commPrice") }}
              {{ priceRange(item.price_range, "comm_price", "min") }}
            </del>
            <span class="text-accent text-xl" :class="isMobile ? ['block'] : []">
              {{ priceRange(item.price_range, "sale_price", "min") }}
            </span>
          </div>
        </div>
      </div>

      <div v-if="!hiddenCart" class="px-2">
        <div class="mt-2">
          <el-button size="large" type="primary" class="w-full btn-view-product blink-border" round
            @click="onOpenProductChooseAssortDialog">
            <i class="fa fa-shopping-cart mr-2" aria-hidden="true"></i>
            選購
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n"
import { breakpoint, dataTranslations as dt, priceRange, convertPriceCurrencies, imgProxy, lookupAliasTranslations } from "../../utils"

const props = defineProps({
  item: Object,
  storeData: Object,
})

const { t, n, locale } = useI18n()
const store = useStore()

const isMobile = computed(() => breakpoint.value.xs)
const currency = computed(() => props.storeData?.currency || 'TWD')
const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const imageUrl = computed(() => {
  if (props.item.image_url) {
    return props.item.image_url;
  }
  return props.item.images?.[0]?.media?.url;
})

const assorts = ref([])

const getAssorts = () => {
  let tmpAssorts = [];
  // console.log("getAssorts: ", props.item.assorts);
  const qty = props.item.assorts.length == 1 ? 1 : 0
  props.item.assorts.forEach((assort) => {
    let data = {
      ...assort,
      store_assort_id: assort.id,
      store_assort_name: dt(assort.name_translations),
      store_product_id: props.item.id,
      store_product_name: dt(props.item.name_translations),
      buy_qty: qty,
    };
    tmpAssorts.push(data)
  });
  assorts.value = tmpAssorts
  // console.log("getAssorts: ", assorts.value);
}

const onOpenProductChooseAssortDialog = () => {
  store.commit('lite/setProductChooseAssortDialog', {
    visible: true,
    data: { ...props.item },
    dataUpdateAt: +new Date(),
  });
}

watch(
  () => props.item,
  (val) => {
    if (val.assorts.length) {
      getAssorts()
    }
  },
  { immediate: true }
)

</script>

<style lang="scss">
.lite-product-item {

  .btn-view-product.blink-border {
    animation: blink-border 1.5s infinite;
  }

  @keyframes blink-border {
    0% {
      border: 3px solid transparent;
    }

    50% {
      border: 3px solid var(--secondary_color);
      color: var(--secondary_color);
    }

    100% {
      border: 3px solid transparent;
    }
  }
}
</style>
